module.exports = __webpack_public_path__ + "img/sec-08-meritz.cddcf436.svg";